export default [
  {
    name: 'admin.templates',
    path: '/admin/templates',
    component() {
      return import('@/views/admin/LetterTemplates.vue')
    },
    meta: {
      authorizedIf: [{ userMatches: { is_coordinator_account: true } }],
    },
  },
  {
    name: 'admin.tasks',
    path: '/admin/tasks',
    component() {
      return import('@/views/admin/Tasks.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_coordinator_account: true } },
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_therapist_account: true } },
        { userMatches: { is_supporter_account: true } },
        { userMatches: { is_supervisor_account: true } },
      ],
      layout: 'blue',
      skipLoadingSpinner: true,
      // skipTranslations: true,
    },
  },
  {
    name: 'admin.task',
    path: '/admin/tasks/:id',
    component() {
      return import('@/views/admin/Task.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_coordinator_account: true } },
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_therapist_account: true } },
        { userMatches: { is_supporter_account: true } },
        { userMatches: { is_supervisor_account: true } },
      ],
      layout: 'blue',
      skipLoadingSpinner: true,
      // skipTranslations: true,
    },
  },
  {
    name: 'admin.cases',
    path: '/admin/cases',
    component() {
      return import('@/views/admin/Cases.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_coordinator_account: true } },
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_therapist_account: true } },
        { userMatches: { is_supporter_account: true } },
        { userMatches: { is_supervisor_account: true } },
      ],
      layout: 'blue',
    },
  },
  {
    name: 'admin.case',
    path: '/admin/cases/:caseId',
    component() {
      return import('@/views/admin/Case.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_coordinator_account: true } },
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_therapist_account: true } },
        { userMatches: { is_supporter_account: true } },
        { userMatches: { is_supervisor_account: true } },
      ],
    },
  },
  {
    name: 'admin.case.log',
    path: '/admin/cases/:caseId/log',
    component() {
      return import('@/views/admin/CaseLog.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_coordinator_account: true } },
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_therapist_account: true } },
        { userMatches: { is_supporter_account: true } },
        { userMatches: { is_supervisor_account: true } },
      ],
    },
  },
  {
    name: 'admin.calendar',
    path: '/admin/interview-calendar',
    component() {
      return import('@/views/interview-booking/Calendar.vue')
    },
    meta: {
      authorizedIf: [
        { userMatches: { is_coordinator_account: true } },
        { userMatches: { is_interviewer_account: true } },
        { userMatches: { is_therapist_account: true } },
        { userMatches: { is_supporter_account: true } },
        { userMatches: { is_supervisor_account: true } },
      ],
      layout: 'blue',
    },
  },
]
